function isInvoiceCarrierValid(invoiceCarrier) {
  // 檢查手機載具規則
  // 第一碼限制為「/」
  // 後面7碼為數字0 - 9、大寫英文A - Z、+、-、.
  const pattern = /^\/[0-9A-Z+\-.]{7}$/;
  if (pattern.test(invoiceCarrier)) {
    return true;
  } else {
    return false;
  }
}

function isVatNumberValid(vatNumber) {
  // 統編驗證（台灣統一編號）
  // 格式檢查：必須是8位數字
  const taxNumberString = vatNumber.toString().trim();

  if (taxNumberString.length !== 8 || !/^\d{8}$/.test(taxNumberString)) {
    return false;
  }

  // 加權數組
  const multipliers = [1, 2, 1, 2, 1, 2, 4, 1];
  let sum = 0;

  // 計算加權總和
  for (let i = 0; i < 8; i++) {
    const digit = parseInt(taxNumberString[i]);
    const product = digit * multipliers[i];
    // 計算位數和：例如 18 -> 1+8=9
    sum += Math.floor(product / 10) + (product % 10);
  }

  // 檢查是否符合整除 5
  if (sum % 5 === 0) {
    return true;
  }

  // 特殊處理：若第七位是 7，且上述總和加 1 後能被 5 整除也算通過
  if (taxNumberString[6] === "7" && (sum + 1) % 5 === 0) {
    return true;
  }

  return false;
}

function isNpoBanValid(npoBan) {
  // 檢查愛心碼
  const pattern = /^\d{3,7}$/;
  return pattern.test(npoBan);
}

function isValidEmail(email) {
  // 使用正規表達式檢查 email 格式
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(email);
}

function isValidPhoneNumber(phone) {
  // 使用正規表達式檢查台灣手機號碼格式
  const phoneNumberPattern = /^09\d{8}$/;
  return phoneNumberPattern.test(phone);
}

function isValidNumber(number) {
  // 檢查是否為數字
  const NumberPattern = /\d{3}$/;
  return NumberPattern.test(number);
}

export default {
  isInvoiceCarrierValid,
  isVatNumberValid,
  isNpoBanValid,
  isValidEmail,
  // Add By Bryant 2025/08/25 Begin
  isValidNumber,
  // Add By Bryant 2025/08/25 End
  isValidPhoneNumber,
};
